var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createElement } from 'react';
import styled, { useTheme } from 'styled-components';
import Skeleton from '../../Progress/Skeleton/Skeleton';
import { IconContext } from 'react-icons';
import { FiSettings as Settings, FiMail as Mail, FiPrinter as Print, FiCalendar as Calendar } from 'react-icons/fi';
import { GoRead as MailOpen, GoGraph as Graph } from 'react-icons/go';
import { AiOutlineMessage as Message, AiOutlineNotification as Notify, AiOutlineShoppingCart as Cart, AiFillLayout as Layout } from 'react-icons/ai';
import { MdOutlineDriveFileRenameOutline as EditName, MdNotificationsNone as Notification, MdTimer as Time, MdPayment as Payment, MdErrorOutline as Error, MdWeb as Domain, MdDelete as Delete, MdNotes as Note, MdMenu as Menu, MdBackspace as BackSpace, MdEditNote as EditNote, MdCategory as Category, MdFilterAlt as Filter, MdFilterAltOff as FilterSlash, MdLogout as Logout, MdSend as Send } from 'react-icons/md';
import { FaCompress as Reduce, FaEquals as Equal, FaShareSquare as Share, FaFolderMinus as RemoveFolder, FaFolderPlus as AddFolder, FaFolderOpen as EmptyFolder, FaHome as Home, FaCheck as Check, FaLanguage as Language, FaAngleUp as ArrowUp, FaAngleDown as ArrowDown, FaPlus as Add, FaRegFileImage as Template, FaSave as Save, FaFileUpload as Upload, FaList as Projects, FaEdit as Pencil, FaTimes as Cross, FaEllipsisV as Ellipsis, FaSearch as Search, FaInfoCircle as InfoCircle, FaInfo as Info, FaQuoteRight as Quote, FaMapMarkerAlt as MapMarker, FaEyeSlash as EyeSlash, FaEye as Eye, FaCircle as Circle, FaRegCircle as CircleEmpty, FaShapes as Shapes, FaAddressBook as Address, FaSortAmountDownAlt as SortDown, FaSortAmountUpAlt as SortUp, FaTable as Table, FaDownload as Download, FaMap as Map, FaExpand as Expand, FaBuilding as Building, FaCode as Code, FaLinkedinIn as Linkedin, FaUsers as People, FaUserAlt as User, FaLock as Lock, FaLockOpen as LockOpen, FaRegHeart as Heart, FaHeart as HeartFull, FaQuestionCircle as Help, FaExchangeAlt as Exchange, FaCompressAlt as Compress, FaExpandAlt as Explode, FaPhone as Phone, FaBookmark as BookmarkFull, FaRegBookmark as Bookmark, FaThumbsDown as ThumbsDownFull, FaRegThumbsDown as ThumbsDown, FaThumbsUp as ThumbsUFull, FaRegThumbsUp as ThumbsUp, FaHistory as History, FaFlag as FlagFull, FaRegFlag as Flag, FaLink as Link, FaChartPie as PieChart, FaPalette as Palette } from 'react-icons/fa';
import { IoIosArrowForward as ArrowRight, IoIosArrowBack as ArrowLeft, IoMdGitNetwork as Network } from 'react-icons/io';
import { BsKanbanFill as StagesFull, BsKanban as Stages, BsStarFill as StarFill, BsStar as Star, BsBagFill as Bag, BsLayoutThreeColumns as Column, BsArrowRepeat as Repeat } from 'react-icons/bs';
import { TiWorld as Web } from 'react-icons/ti';
import { IoDocumentTextOutline as Document } from 'react-icons/io5';
import { BiSupport as Support, BiRectangle as Rectangle, BiMapPin as Cluster } from 'react-icons/bi';
import { RiHeartAddFill as AddHeartFull, RiHeartAddLine as AddHeart, RiKanbanView2 as KanbanView, RiRobot2Fill as MatchyFull, RiRobot2Line as Matchy } from 'react-icons/ri';
import { PiArrowFatLinesUpFill as FatArrowUp, PiArrowFatLinesDownFill as FatArrowDown, PiWarningFill as Warning } from 'react-icons/pi';
import { TbPin as Pin, TbPinFilled as PinFull, TbPinnedOff as PinSlash } from 'react-icons/tb';
import { ImCheckboxChecked as Checked, ImNewTab as NewTab } from 'react-icons/im';
import { FaFaceMeh as FaceMeh, FaFaceFrown as FaceSad, FaFaceSmile as FaceSmile } from 'react-icons/fa6';
import Heatmap from './Heatmap';
const IconWrapper = styled.div `
  box-sizing: border-box;
  display: inline-flex;
  align-items: center;
  cursor: ${props => props.cursor};
  margin: ${props => props.noMargin ? '0rem' : props.theme.paddingsMargins.themeMenuMargin};
  ${props => props.mediaQuery};
`;
const components = {
    message: Message,
    home: Home,
    cart: Cart,
    payment: Payment,
    print: Print,
    mail: Mail,
    mailOpen: MailOpen,
    time: Time,
    graph: Graph,
    settings: Settings,
    calendar: Calendar,
    notify: Notify,
    notification: Notification,
    check: Check,
    error: Error,
    language: Language,
    arrowUp: ArrowUp,
    arrowDown: ArrowDown,
    arrowRight: ArrowRight,
    arrowLeft: ArrowLeft,
    domain: Domain,
    delete: Delete,
    add: Add,
    template: Template,
    save: Save,
    upload: Upload,
    starFill: StarFill,
    star: Star,
    note: Note,
    editNote: EditNote,
    projects: Projects,
    pencil: Pencil,
    cross: Cross,
    menu: Menu,
    ellipsis: Ellipsis,
    search: Search,
    infoCircle: InfoCircle,
    info: Info,
    quote: Quote,
    marker: MapMarker,
    eyeSlash: EyeSlash,
    eye: Eye,
    filter: Filter,
    filterSlash: FilterSlash,
    circle: Circle,
    circleEmpty: CircleEmpty,
    shapes: Shapes,
    bag: Bag,
    address: Address,
    sortDown: SortDown,
    sortUp: SortUp,
    table: Table,
    download: Download,
    map: Map,
    web: Web,
    column: Column,
    layout: Layout,
    expand: Expand,
    network: Network,
    backSpace: BackSpace,
    building: Building,
    code: Code,
    linkedin: Linkedin,
    people: People,
    user: User,
    lock: Lock,
    lockOpen: LockOpen,
    heart: Heart,
    heartFull: HeartFull,
    document: Document,
    exchange: Exchange,
    compress: Compress,
    explode: Explode,
    help: Help,
    cluster: Cluster,
    rectangle: Rectangle,
    addHeart: AddHeart,
    addHeartFull: AddHeartFull,
    phone: Phone,
    category: Category,
    bookmark: Bookmark,
    bookmarkFull: BookmarkFull,
    thumbsDownFull: ThumbsDownFull,
    thumbsDown: ThumbsDown,
    thumbsUpFull: ThumbsUFull,
    thumbsUp: ThumbsUp,
    repeat: Repeat,
    pin: Pin,
    pinFull: PinFull,
    pinSlash: PinSlash,
    emptyFolder: EmptyFolder,
    addFolder: AddFolder,
    removeFolder: RemoveFolder,
    editName: EditName,
    share: Share,
    history: History,
    flag: Flag,
    flagFull: FlagFull,
    link: Link,
    stages: Stages,
    kanban: KanbanView,
    stagesFull: StagesFull,
    support: Support,
    fatArrowUp: FatArrowUp,
    fatArrowDown: FatArrowDown,
    equal: Equal,
    checked: Checked,
    pieChart: PieChart,
    reduce: Reduce,
    newTab: NewTab,
    warning: Warning,
    palette: Palette,
    logout: Logout,
    faceMeh: FaceMeh,
    faceSad: FaceSad,
    faceSmile: FaceSmile,
    matchyFull: MatchyFull,
    matchy: Matchy,
    send: Send
};
export const iconArray = [
    'message',
    'home',
    'cart',
    'payment',
    'print',
    'mail',
    'mailOpen',
    'time',
    'graph',
    'settings',
    'calendar',
    'notify',
    'notification',
    'check',
    'error',
    'language',
    'arrowUp',
    'arrowDown',
    'arrowRight',
    'arrowLeft',
    'domain',
    'delete',
    'add',
    'template',
    'save',
    'upload',
    'starFill',
    'star',
    'note',
    'editNote',
    'projects',
    'pencil',
    'cross',
    'menu',
    'ellipsis',
    'search',
    'infoCircle',
    'info',
    'quote',
    'marker',
    'eyeSlash',
    'eye',
    'filter',
    'filterSlash',
    'circle',
    'circleEmpty',
    'shapes',
    'bag',
    'address',
    'sortDown',
    'sortUp',
    'table',
    'download',
    'map',
    'web',
    'column',
    'layout',
    'expand',
    'network',
    'backSpace',
    'building',
    'code',
    'linkedin',
    'people',
    'user',
    'lock',
    'lockOpen',
    'heart',
    'heartFull',
    'help',
    'exchange',
    'compress',
    'explode',
    'document',
    'rectangle',
    'cluster',
    'addHeart',
    'addHeartFull',
    'phone',
    'category',
    'bookmark',
    'bookmarkFull',
    'thumbsDown',
    'thumbsDownFull',
    'thumbsUp',
    'thumbsUpFull',
    'repeat',
    'pin',
    'pinFull',
    'pinSlash',
    'emptyFolder',
    'addFolder',
    'removeFolder',
    'editName',
    'share',
    'history',
    'flag',
    'flagFull',
    'link',
    'stages',
    'stagesFull',
    'kanban',
    'support',
    'fatArrowUp',
    'fatArrowDown',
    'equal',
    'checked',
    'pieChart',
    'reduce',
    'newTab',
    'warning',
    'palette',
    'logout',
    'faceMeh',
    'faceSad',
    'faceSmile',
    'matchy',
    'matchyFull',
    'send'
];
const Icon = (_a) => {
    var { icon, cursor = 'pointer', size = 'article', color = 'main', isDisabled = false, secondary = false, isLoading = false, noMargin = false, skeleton, mediaQuery } = _a, props = __rest(_a, ["icon", "cursor", "size", "color", "isDisabled", "secondary", "isLoading", "noMargin", "skeleton", "mediaQuery"]);
    const theme = useTheme();
    const Icon = components[icon];
    const iconColor = isDisabled
        ? theme.utils.getColor('dark')
        : secondary ? theme.utils.getColor('secondary') : theme.utils.getColor(color);
    const iconSize = theme.utils.getSize(size);
    return (_jsx(IconWrapper, Object.assign({ cursor: cursor, noMargin: noMargin, mediaQuery: mediaQuery }, props, { children: isLoading
            ? _jsx(Skeleton, { height: size, width: size })
            : icon === 'heatmap'
                ? _jsx(Heatmap, { color: color, size: size, theme: theme })
                : _jsx(IconContext.Provider, Object.assign({ value: { color: iconColor, size: iconSize } }, { children: Icon ? createElement(Icon) : 'wrong icon name' })) })));
};
export default Icon;
